import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import {
  borderWidth,
  borderStyle,
  borderRadius,
} from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { spacing } from "../../../design-system/tokens/spacing";

/** Horizontal flex row that holds the stacked avatars. */
export const Row = styled.div`
  display: inline-flex;
  align-items: center;
`;

/**
 * One avatar slot — common positioning so photo + initials + "+N" all align.
 * `$size` is the diameter in px. Overlap is achieved via negative right margin
 * (`-${spacing[2]}` = -8px) — except on the last slot.
 */
export const Slot = styled.div<{ $size: number; $isLast?: boolean }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  flex-shrink: 0;
  margin-right: ${({ $isLast }) => ($isLast ? "0" : `-${spacing[2]}`)};
  position: relative;
`;

/** Photo layered over the initials; a broken photo is hidden to reveal them. */
export const PhotoAvatar = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

/** Initials circle; the photo sits on top of it. */
export const InitialsAvatar = styled.div<{ $size: number }>`
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: ${borderRadius.full};
  border: 2px solid ${rawColors.structural.white};
  background: ${rawColors.primary[100]};
  color: ${rawColors.primary[500]};
  display: flex;
  align-items: center;
  justify-content: center;
  ${typographyMixin("caption", 3)}
  text-transform: uppercase;
  user-select: none;
`;

/**
 * "+N" overflow chip — Figma: bg `greys/300 #EEEDF2`, border `greys/500 #AFADBA`,
 * text `text/low-emphasis #7A7287` 14/24 Medium, radius 999.
 */
export const OverflowAvatar = styled.div<{ $size: number }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: ${borderRadius.full};
  border: ${borderWidth[1]} ${borderStyle.solid} ${rawColors.grey[500]};
  background: ${rawColors.grey[300]};
  color: ${rawColors.text.lowEmphasis};
  display: flex;
  align-items: center;
  justify-content: center;
  ${typographyMixin("body", 3)}
  user-select: none;
`;
